/**
 * Widget-Kalender: Fremdbelegung einheitlich rot; gewählter Zeitraum Emerald-700 wie im Backoffice.
 */
import type { WidgetAvailabilityBlock } from './stay-calendar-constraints'
import { enumerateDates } from './stay-calendar-constraints'

/** Einheitliche Darstellung „nicht verfügbar“ im öffentlichen Widget (Tailwind rose-700). */
const WIDGET_BLOCKED_RGB_TRIPLE = '190, 18, 60'

export type OccupancyRgbMaps = {
  night: Map<string, string>
  arrival: Map<string, string>
  departure: Map<string, string>
}

export function buildOccupancyRgbMaps(blocks: WidgetAvailabilityBlock[]): OccupancyRgbMaps {
  const night = new Map<string, string>()
  const arrival = new Map<string, string>()
  const departure = new Map<string, string>()
  const rgb = WIDGET_BLOCKED_RGB_TRIPLE
  for (const b of blocks) {
    const f = b.stay_from?.trim()
    const t = b.stay_to?.trim()
    if (f) arrival.set(f, rgb)
    if (t) departure.set(t, rgb)
    if (f && t) {
      // [stay_from, stay_to): Anreisetag nur Schraffur (halb frei), keine volle Nachtfläche.
      for (const d of enumerateDates(f, t)) {
        if (d === f) continue
        night.set(d, rgb)
      }
    }
  }
  return { night, arrival, departure }
}

/** Tailwind emerald-700 */
export const SELECTION_RGB_TRIPLE = '4, 120, 87'

export function occupancyNightLayerStyle(triple: string): string {
  return `background-color:rgba(${triple},0.17);border:1px solid rgba(${triple},0.38);box-sizing:border-box;`
}

export function occupancyArrivalLayerStyle(triple: string): string {
  const c = `rgba(${triple},0.34)`
  return `background:linear-gradient(315deg,${c} 0%,${c} 49.5%,transparent 50%);`
}

export function occupancyDepartureLayerStyle(triple: string): string {
  const c = `rgba(${triple},0.34)`
  return `background:linear-gradient(135deg,${c} 0%,${c} 49.5%,transparent 50%);`
}

export function selectionStartHalfStyle(): string {
  const c = `rgba(${SELECTION_RGB_TRIPLE},0.92)`
  return `background:linear-gradient(315deg,${c} 0%,${c} 49.5%,transparent 50%);`
}

export function selectionEndHalfStyle(): string {
  const c = `rgba(${SELECTION_RGB_TRIPLE},0.92)`
  return `background:linear-gradient(135deg,${c} 0%,${c} 49.5%,transparent 50%);`
}
